import { App } from "vue";
import { toastCreate } from "y-design/libs/toast";

import "y-design/packages/toast/src/style.scss";

interface IToastParams {
  title: string;
  message?: string;
  animationDuration?: number;
  position?: string;
  duration?: number;
  onClose?: () => void;
}

type IToast = (params: IToastParams) => void;

export default {
  provide(app: App): void {
    app.provide("toast", toastCreate as IToast);
  },
  inject(): IToast {
    return inject("toast", () => null);
  },
};
